module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-annual--cover.372741ab.jpg";